export const BASE_URL = "https://shivam-medium-learn.onrender.com/blogsdata/"

export const auth = "authorization"

